export const notification_icon = (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5585 9.06822C9.67403 10.6917 8.64924 14.3553 10.2727 17.2398L11.6902 19.7583C11.9894 20.2899 12.219 21.2279 12.2039 21.8331L12.1386 24.0616C12.0986 25.4382 13.1682 26.3394 14.5169 26.0852C18.9791 25.2261 23.0313 22.9454 26.081 19.5765C26.9393 18.6344 26.6997 17.1283 25.585 16.4934L23.646 15.393C23.1296 15.087 22.4468 14.4041 22.1476 13.8725L20.7301 11.354C19.1115 8.47823 15.4343 7.44962 12.5585 9.06822Z"
      stroke="#737791"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M14.3126 8.41354C13.9983 8.48716 13.6851 8.58312 13.3779 8.71012C12.4825 9.07641 11.7151 9.58866 11.0882 10.2283C10.978 9.44122 11.3504 8.63492 12.0824 8.22291C12.8144 7.81091 13.6969 7.91091 14.3126 8.41354Z"
      stroke="#737791"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.0939 21.6707C23.9032 23.1086 23.3889 24.9472 21.951 25.7565C21.2364 26.1587 20.4074 26.2352 19.6719 26.0294C18.9365 25.8237 18.2674 25.3282 17.8652 24.6136"
      stroke="#737791"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    {/* <circle cx="20.5" cy="10.4982" r="4.5" fill="#FF0020" /> */}
  </svg>
);
